<!-- Header-BP -->

<header class="header" id="site-header" *ngIf="lang =='ar'" >

    <div class="page-title">
        <a routerLink="/home">
            <img src="assets/img/logo.webp" width="150" alt="logo" style="margin-top: -33px;">
        </a>
    </div>
    <div class="header-content-wrapper" > 
        <a style="font-size: 30px; color: #fff; top:15px; right:30px; position: relative; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">عائلات كرة القدم</a>
        <div class="control-block">       
            <div class="control-icon more has-items">
                <a routerLink="/home">
                    <i class="fad fa-home" style="width: 30px; font-size: 30px; color: white;"></i>
                </a>
            </div>
            <div class="control-icon more has-items">
                <a class="h6 notification-friend"><i class="fad fa-globe" style="width: 30px; font-size: 30px; color: white;"></i></a>
                <div class="more-dropdown more-with-triangle triangle-top-center">
                    <div class="mCustomScrollbar" data-mcs-theme="dark">
                        <ul class="notification-list friend-requests">
                            <li (click)="selectedLanguage('en','ltr')">
                                <div class="author-thumb">
                                    <img src="assets/svg-icons/1x1/en.svg" alt="language" width="100%">
                                </div>
                                <div class="notification-event">
                                    <a href="javascript:void(0);" class="h6 notification-friend">English</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="control-icon more has-items">
            <button (click)="toggleTheme()" style="background-color: #093952; color: white;">
                <i class="fad fa-adjust" style="width: 30px; font-size: 30px; color: white;"></i>
            </button>
            </div>
            <div *ngFor="let item1 of notification" class="control-icon more has-items button">
                <a routerLink="/friend-requests">
                    <i class="fad fa-user-clock" style="width: 30px; font-size: 30px; color: white;"></i>
                    <span class="button__badge">{{item1.Noticount}}</span>
                </a>
            </div>
            <div class="author-page author vcard inline-items more">
                <div class="author-thumb">
                    <a routerLink="/profile">
                        <img *ngIf="!currentUser.success.user.avatar" alt="author" src="assets/img/author-page.jpg"
                            class="avatar" width="36" height="36"
                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                            style="width: 36px; height: 36px;">
                        <img *ngIf="currentUser.success.user.avatar" alt="author" [src]="userData[0].avatar"
                            class="avatar" width="36" height="36"
                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                            style="width: 36px; height: 36px;">
                        <!-- <span class="icon-status online"> </span> -->
                    </a>
                </div>
                <a routerLink="/profile" class="author-name fn">
                    <div class="author-title">
                        {{ currentUser.success.user.fullName | titlecase }}
                    </div>
                    <!-- <span class="author-subtitle">SPACE COWBOY</span> -->
                </a>
            </div>
        </div>
    </div>

</header>

<header class="header" id="site-header" *ngIf="lang !='ar'" >
    <div class="page-title">
        <a routerLink="/home">
            <img src="assets/img/logo.webp" width="150" alt="logo" style="margin-top: -33px;">
        </a>
    </div>
    <div class="header-content-wrapper" >
        <a style="font-size: 30px; color: #fff; top:15px; right:30px; position: relative;">FOOTBALL FAMILIES</a>
        <div class="control-block">
            <div class="control-icon more has-items ">
                <a routerLink="/home">
                    <i class="fad fa-home" style="width: 30px; font-size: 30px; color: white;"></i>
                </a>
            </div>
            <div class="control-icon more has-items">
                <a class="h6 notification-friend"><i class="fad fa-globe" style="width: 30px; font-size: 30px; color: white;"></i></a>
                <div class="more-dropdown more-with-triangle triangle-top-center">
                    <div class="mCustomScrollbar" data-mcs-theme="dark">
                        <ul class="notification-list friend-requests">
                            <li (click)="selectedLanguage('ar','rtl')">
                                <div class="author-thumb">
                                    <img src="assets/svg-icons/1x1/sa.svg" alt="language" width="100%">
                                </div>
                                <div class="notification-event">
                                    <a href="javascript:void(0);" class="h6 notification-friend" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">العربية</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="control-icon more has-items">
            <button (click)="toggleTheme()" style="background-color: #093952; color: white;">
                <i class="fad fa-adjust" style="width: 30px; font-size: 30px; color: white;"></i>
            </button>
            </div>
            <div *ngFor="let item1 of notification" class="control-icon more has-items button">
                <a routerLink="/friend-requests">
                    <i class="fad fa-user-clock" style="width: 30px; font-size: 30px; color: white;"></i>
                    <span class="button__badge">{{item1.Noticount}}</span>
                </a>
            </div>
            <div class="author-page author vcard inline-items more">
                <div class="author-thumb">
                    <a routerLink="/profile">
                        <img *ngIf="!currentUser.success.user.avatar" alt="author" src="assets/img/author-page.jpg"
                            class="avatar" width="36" height="36"
                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                            style="width: 36px; height: 36px;">
                        <img *ngIf="currentUser.success.user.avatar" alt="author" [src]="userData[0].avatar"
                            class="avatar" width="36" height="36"
                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                            style="width: 36px; height: 36px;">
                        <!-- <span class="icon-status online"> </span> -->
                    </a>
                </div>
                <a routerLink="/profile" class="author-name fn">
                    <div class="author-title">
                        {{ currentUser.success.user.fullName | titlecase }} 
                    </div>
                    <!-- <span class="author-subtitle">SPACE COWBOY</span> -->
                </a>
            </div>
        </div>
    </div>

</header>
<!-- ... end Header-BP -->


<!-- Responsive Header-BP -->
<header class="header header-responsive" id="site-header-responsive" [dir]="direction">

    <div class="header-content-wrapper">
        <ul class="nav nav-tabs mobile-app-tabs" role="tablist">
            <li class="nav-item">
                <a class="nav-link" routerLink="/home">
                    <div class="control-icon has-items">
                        <img src="assets/svg-icons/home-icon.png" alt="Home" style="width: 30px;">
                    </div>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#notification" role="tab">
                    <div class="control-icon has-items">
                        <img src="assets/img/translation.png" alt="Language" style="width: 30px;">
                    </div>
                    <div class="more-dropdown more-with-triangle triangle-top-center">

                        <div class="mCustomScrollbar" data-mcs-theme="dark">
                            <ul class="notification-list friend-requests">
                                <li (click)="selectedLanguage('en','ltr')">
                                    <div class="author-thumb">
                                        <img src="assets/svg-icons/1x1/en.svg" alt="language" width="100%">
                                    </div>
                                    <div class="notification-event">
                                        <a href="javascript:void(0);" class="h6 notification-friend">English</a>
                                    </div>
                                </li>

                                <li (click)="selectedLanguage('ar','rtl')">
                                    <div class="author-thumb">
                                        <img src="assets/svg-icons/1x1/sa.svg" alt="language" width="100%">
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </a>
            </li>


            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#notification" role="tab">
                    <div class="control-icon has-items">
                        <img src="assets/svg-icons/notification.png" alt="Home" style="width: 30px;">
                        <!-- <div class="label-avatar bg-primary">0</div> -->
                    </div>
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#search" role="tab">
                    <svg class="olymp-magnifying-glass-icon">
                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-magnifying-glass-icon"></use>
                    </svg>
                    <svg class="olymp-close-icon">
                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                    </svg>
                </a>
            </li>
        </ul>
    </div>

    <!-- Tab panes -->
    <div class="tab-content tab-content-responsive">

        <div class="tab-pane " id="request" role="tabpanel">

            <div class="mCustomScrollbar" data-mcs-theme="dark">
                <div class="ui-block-title ui-block-title-small">
                    <h6 class="title">FRIEND REQUESTS</h6>
                    <a href="#">Find Friends</a>
                    <a href="#">Settings</a>
                </div>
                <ul class="notification-list friend-requests">
                    <li>
                        <div class="author-thumb">
                            <img src="assets/img/avatar55-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Tamara Romanoff</a>
                            <span class="chat-message-item">Mutual Friend: Sarah Hetfield</span>
                        </div>
                        <span class="notification-icon">
                            <a href="#" class="accept-request">
                                <span class="icon-add without-text">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                            <a href="#" class="accept-request request-del">
                                <span class="icon-minus">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                        </span>

                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div class="author-thumb">
                            <img src="assets/img/avatar56-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Tony Stevens</a>
                            <span class="chat-message-item">4 Friends in Common</span>
                        </div>
                        <span class="notification-icon">
                            <a href="#" class="accept-request">
                                <span class="icon-add without-text">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                            <a href="#" class="accept-request request-del">
                                <span class="icon-minus">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                        </span>

                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>
                    <li class="accepted">
                        <div class="author-thumb">
                            <img src="assets/img/avatar57-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            You and <a href="#" class="h6 notification-friend">Mary Jane Stark</a> just became friends.
                            Write on <a href="#" class="notification-link">her wall</a>.
                        </div>
                        <span class="notification-icon">
                            <svg class="olymp-happy-face-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon"></use>
                            </svg>
                        </span>

                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                            <svg class="olymp-little-delete">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div class="author-thumb">
                            <img src="assets/img/avatar58-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Stagg Clothing</a>
                            <span class="chat-message-item">9 Friends in Common</span>
                        </div>
                        <span class="notification-icon">
                            <a href="#" class="accept-request">
                                <span class="icon-add without-text">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                            <a href="#" class="accept-request request-del">
                                <span class="icon-minus">
                                    <svg class="olymp-happy-face-icon">
                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-happy-face-icon">
                                        </use>
                                    </svg>
                                </span>
                            </a>

                        </span>

                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>
                </ul>
                <a href="#" class="view-all bg-blue">Check all your Events</a>
            </div>

        </div>

        <div class="tab-pane " id="chat" role="tabpanel">

            <div class="mCustomScrollbar" data-mcs-theme="dark">
                <div class="ui-block-title ui-block-title-small">
                    <h6 class="title">Chat / Messages</h6>
                    <a href="#">Mark all as read</a>
                    <a href="#">Settings</a>
                </div>

                <ul class="notification-list chat-message">
                    <li class="message-unread">
                        <div class="author-thumb">
                            <img src="assets/img/avatar59-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Diana Jameson</a>
                            <span class="chat-message-item">Hi James! It’s Diana, I just wanted to let you know that we
                                have to reschedule...</span>
                            <span class="notification-date"><time class="entry-date updated"
                                    datetime="2004-07-24T18:18">4 hours ago</time></span>
                        </div>
                        <span class="notification-icon">
                            <svg class="olymp-chat---messages-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-chat---messages-icon"></use>
                            </svg>
                        </span>
                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>

                    <li>
                        <div class="author-thumb">
                            <img src="assets/img/avatar60-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Jake Parker</a>
                            <span class="chat-message-item">Great, I’ll see you tomorrow!.</span>
                            <span class="notification-date"><time class="entry-date updated"
                                    datetime="2004-07-24T18:18">4 hours ago</time></span>
                        </div>
                        <span class="notification-icon">
                            <svg class="olymp-chat---messages-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-chat---messages-icon"></use>
                            </svg>
                        </span>

                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div class="author-thumb">
                            <img src="assets/img/avatar61-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">Elaine Dreyfuss</a>
                            <span class="chat-message-item">We’ll have to check that at the office and see if the client
                                is on board with...</span>
                            <span class="notification-date"><time class="entry-date updated"
                                    datetime="2004-07-24T18:18">Yesterday at 9:56pm</time></span>
                        </div>
                        <span class="notification-icon">
                            <svg class="olymp-chat---messages-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-chat---messages-icon"></use>
                            </svg>
                        </span>
                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>

                    <li class="chat-group">
                        <div class="author-thumb">
                            <img src="assets/img/avatar11-sm.jpg" alt="author">
                            <img src="assets/img/avatar12-sm.jpg" alt="author">
                            <img src="assets/img/avatar13-sm.jpg" alt="author">
                            <img src="assets/img/avatar10-sm.jpg" alt="author">
                        </div>
                        <div class="notification-event">
                            <a href="#" class="h6 notification-friend">You, Faye, Ed &amp; Jet +3</a>
                            <span class="last-message-author">Ed:</span>
                            <span class="chat-message-item">Yeah! Seems fine by me!</span>
                            <span class="notification-date"><time class="entry-date updated"
                                    datetime="2004-07-24T18:18">March 16th at 10:23am</time></span>
                        </div>
                        <span class="notification-icon">
                            <svg class="olymp-chat---messages-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-chat---messages-icon"></use>
                            </svg>
                        </span>
                        <div class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use>
                            </svg>
                        </div>
                    </li>
                </ul>

                <a href="#" class="view-all bg-purple">View All Messages</a>
            </div>

        </div>

        <div class="tab-pane " id="notification" role="tabpanel">

            <div class="mCustomScrollbar" data-mcs-theme="dark">
                <ul class="notification-list friend-requests">
                    <li (click)="selectedLanguage('en','ltr')">
                        <div class="author-thumb">
                            <img src="assets/svg-icons/1x1/en.svg" alt="language" width="100%">
                        </div>
                        <div class="notification-event">
                            <a href="javascript:void(0);" class="h6 notification-friend">English</a>
                        </div>
                    </li>

                    <li (click)="selectedLanguage('de','ltr')">
                        <div class="author-thumb">
                            <img src="assets/svg-icons/1x1/de.svg" alt="language" width="100%">
                        </div>
                        <div class="notification-event">
                            <a href="javascript:void(0);" class="h6 notification-friend">German</a>
                        </div>
                    </li>
                    <li (click)="selectedLanguage('ar','rtl')">
                        <div class="author-thumb">
                            <img src="assets/svg-icons/1x1/sa.svg" alt="language" width="100%">
                        </div>
                        <div class="notification-event">
                            <a href="javascript:void(0);" class="h6 notification-friend">Arabic</a>
                        </div>
                    </li>
                    <li (click)="selectedLanguage('fr','ltr')">
                        <div class="author-thumb">
                            <img src="assets/svg-icons/1x1/fr.svg" alt="language" width="100%">
                        </div>
                        <div class="notification-event">
                            <a href="javascript:void(0);" class="h6 notification-friend">French</a>
                        </div>
                    </li>

                </ul>
            </div>

        </div>


    </div>

</header>

<!-- ... end Responsive Header-BP -->
<div class="header-spacer"></div>